import wsgsig from '@didi/wsgsig'
import qs from 'qs'
import {type} from '../utils'

function checkWhiteList(url, whiteList) {
  if (/^\/[^/]/.test(url)) {
    // 转换根路径url（/xx/yy）
    const location = window.location
    url = `${location.protocol}//${location.host}${url}`
  }
  return whiteList.some(item => {
    return item === '*' || (type(item) === 'RegExp' ? item.test(url) : url.indexOf(item) > -1)
  })
}

export default function sign(config) {
  const needEncrypt = config.needEncrypt === undefined
    ? checkWhiteList(config.url, config.signWhiteList || [])
    : config.needEncrypt
  if (!needEncrypt) {
    return config
  }
  const needSignDatas = []
  if (config.params && Object.keys(config.params).length) {
    needSignDatas.push(config.params)
  }
  if (/^post|put$/i.test(config.method) && config.data) {
    let data = config.data
    const isJSON = /application\/json/i.test(config.headers['Content-Type'])
    if (!isJSON && typeof data === 'string') {
      try {
        data = qs.parse(data)
      } catch (e) {
        data = null
      }
    } else if (isJSON && typeof data === 'object') {
      data = JSON.stringify(data)
    }
    if (data) {
      needSignDatas[0] ? needSignDatas.push(data) : needSignDatas.push({}, data)
    }
  }
  needSignDatas.length && (config.params = Object.assign({}, config.params, {
    wsgsig: wsgsig.getSign(...needSignDatas)
  }))

  return config
}
